let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hp1Pp")).then(() => parcelRequire('iCgP0'));